import e from "@dialpad/dialtone-tokens/layered/tokens-dp-colors.css?inline";
//#region themes/dp.js
var t = { brand: {
	css: e,
	name: "dp"
} };
//#endregion
export { t as default };
